import { eventsApi } from '../../../../../../api/eventsApi';
import { sessionsApi } from '../../../../../../api/sessionsApi';
import { externalIdsMatch, savedLinksOf } from './externalLinks';

const ensureSaved = (storedId, expectedId, label) => {
  if (expectedId && !externalIdsMatch(storedId, expectedId)) {
    throw new Error(
      `${label} session ID was not saved on the session. The API may need to be redeployed, or enter the session ID manually and try again.`
    );
  }
};

/** Save session and event links, then re-read the session to confirm they stuck. */
export const persistLinks = async (sessionId, eventId, values) => {
  const sessionPayload = {};
  if (values.wpSessionId) {
    sessionPayload.wp_session_id = values.wpSessionId;
    sessionPayload.wpSessionId = values.wpSessionId;
  }
  if (values.faiconSessionId) {
    sessionPayload.faicon_session_id = values.faiconSessionId;
    sessionPayload.faiconSessionId = values.faiconSessionId;
  }
  const sessionUpdated = Object.keys(sessionPayload).length > 0;
  if (sessionUpdated) await sessionsApi.update(sessionId, sessionPayload);

  const eventUpdated = Boolean(eventId && (values.eventWpId || values.eventFaiconId));
  if (eventUpdated) {
    const eventPayload = {};
    if (values.eventWpId) eventPayload.wp_id = values.eventWpId;
    if (values.eventFaiconId) eventPayload.faicon_id = values.eventFaiconId;
    await eventsApi.update(eventId, eventPayload);
  }

  const stored = savedLinksOf(await sessionsApi.get(sessionId));
  ensureSaved(stored.faiconSessionId, values.faiconSessionId, 'Faicon');
  ensureSaved(stored.wpSessionId, values.wpSessionId, 'WordPress');
  return { sessionUpdated, eventUpdated };
};
